<template>
  <el-container  type="flex" class="main_container">
    <base-header>
      团长总数：{{this.content.seller_total_count}}
      <span>&emsp;&emsp;</span>
      团长转化率：{{this.content.seller_trans_rate}}
    </base-header>
    <el-main>
      <div class="chart_box">
        <base-chart
          chartUrl="seller_daily"
          chartText="团长日增长"
          want="seller_count"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="seller_monthly"
          chartText="团长月增长"
          want="seller_count"
          :total="total_month"
        ></base-chart>
        <base-chart
          chartUrl="seller_incr_rate_daily"
          chartText="团长日增长率"
          want="seller_incr_rate"
          type="percent"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="seller_incr_rate_monthly"
          chartText="团长月增长率"
          want="seller_incr_rate"
          type="percent"
          :total="total_month"
        ></base-chart>
        <base-chart
          chartUrl="seller_dau"
          chartText="团长日活"
          want="seller_dau"
          :total="total_day"
        ></base-chart>
        <base-chart
          chartUrl="seller_mau"
          chartText="团长月活"
          want="seller_mau"
          :total="total_month"
        ></base-chart>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import chartMixin from '../../../../mixins/chart'

export default {
  name: 'DBIncome',
  mixins: [chartMixin]
}
</script>
